import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const Cell = styled.div`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 6px;
    pointer-events: none;
    background: linear-gradient(to right, #ffffff00, #d8d8d820 70%, #d8d8d880);
  }
`;

interface TableDataRowProps {
  row: any;
  isExpanded: boolean;
  // isResizing is used for performance optimization
  isResizing: boolean;
}

interface TableDataCellProps {
  cellProps: any;
  contentAlign: string;
  className: string;
  render: (type: 'Cell') => React.ReactNode;
}

const TableDataCell: React.FC<TableDataCellProps> = ({
  contentAlign,
  className,
  cellProps,
  render,
}) => {
  return (
    <Cell
      className={classNames('td', className, {
        'align-left': contentAlign === 'left',
        'align-center': contentAlign === 'center',
      })}
      {...cellProps}
    >
      {render('Cell')}
    </Cell>
  );
};

const TableDataRow: React.FC<TableDataRowProps> = React.memo(
  function TableDataRow(props) {
    const { row, isExpanded } = props;
    return (
      <div
        className={classNames('tr', { expanded: isExpanded })}
        {...row.getRowProps()}
      >
        {row.cells.map((cell, i) => {
          const { contentAlign, className } = cell.column;
          return (
            <TableDataCell
              contentAlign={contentAlign}
              className={className}
              key={i}
              cellProps={cell.getCellProps()}
              render={cell.render}
            />
          );
        })}
      </div>
    );
  }
);

export default TableDataRow;
